import { Alert } from "@mui/material";
const ErroApi = ({ msg }) => {
  return (
    <Alert severity="error">
      {msg}
    </Alert>
  );
};

export default ErroApi;